<template>
	<div class="how-to-participate">
		<div class="container">
			<p class="important-note">
				Have you visited any of the Mekong countries in the past? <br />
				Participating at the Mekong Memories campaign is quite simple. <br />
				<span class="highlight">Just follow these steps:</span>
			</p>
			<div class="rule-list">
				<div class="rule-item">
					<div class="number">1</div>
					<div class="text">
						<strong>Find you best and inspirational holiday images and videos</strong> from you last trip(s)
						in the Greater Mekong Subregion (Cambodia, PR China (Guangxi, and Yunnan provinces), Lao PDR,
						Myanmar, Thailand, and Viet Nam).
					</div>
					<div class="icon d-none d-md-block">
						<img :src="images.list1" />
					</div>
				</div>

				<div class="rule-item">
					<div class="number">2</div>
					<div class="text">
						<strong>Post them</strong> to your social media channels: Instagram, Twitter, or YouTube.
					</div>
					<div class="icon d-none d-md-block">
						<img :src="images.list2" />
					</div>
				</div>

				<div class="rule-item">
					<div class="number">3</div>
					<div class="text">
						<strong>Tag them with #MekongMemories</strong> and #Country/Destination. You can also add a
						location or business #.
					</div>
					<div class="icon d-none d-md-block">
						<img :src="images.list3" />
					</div>
				</div>

				<div class="rule-item">
					<div class="number">4</div>
					<div class="text">
						Once your post is approved,
						<strong>share it with your friends and invite them to like it</strong> on MekongMemories.com to
						win travel prizes in the Mekong Region.
					</div>
					<div class="icon d-none d-md-block">
						<img :src="images.list4" />
					</div>
				</div>
			</div>
			<p class="important-note">
				<strong
					>Share and inspire others to #traveltomorrow and experience the wonders of the Mekong
					Region.</strong
				>
			</p>

			<div class="gallery">
				<img :src="images.pic1" />
				<img :src="images.pic2" />
				<img :src="images.pic3" />
			</div>
		</div>
	</div>
</template>

<script>
import list1 from '@/assets/images/inspirator.svg';
import list2 from '@/assets/images/social-networks.svg';
import list3 from '@/assets/images/hashtag.svg';
import list4 from '@/assets/images/heart.svg';
import pic1 from '@/assets/images/how-to-1.png';
import pic2 from '@/assets/images/how-to-2.png';
import pic3 from '@/assets/images/how-to-3.png';
export default {
	data() {
		return {
			images: {
				list1,
				list2,
				list3,
				list4,
				pic1,
				pic2,
				pic3,
			},
		};
	},
};
</script>

<style lang="scss">
.how-to-participate {
	.highlight {
		color: #da006a;
	}

	.important-note {
		font-weight: bold;
		font-size: 24px;
		margin-top: 30px;
	}

	.rule-list {
		.rule-item {
			display: flex;
			justify-content: space-between;
			align-items: center;
			margin-top: 30px;
			font-size: 18px;

			.number {
				margin-right: 50px;
				color: #fff;
				font-weight: bold;
				font-size: 24px;
				width: 55px;
				height: 55px;
				display: flex;
				justify-content: center;
				align-items: center;
				flex: 0 0 auto;
			}

			.text {
				flex: 1 1 auto;
			}

			.text strong {
				font-weight: bold;
			}

			.icon {
				margin-left: 50px;
			}
		}

		.rule-item:nth-child(1) {
			.number {
				background-color: #1d602e;
			}
			strong {
				color: #1d602e;
			}
		}

		.rule-item:nth-child(2) {
			.number {
				background-color: #dc0a20;
			}
			strong {
				color: #dc0a20;
			}
		}

		.rule-item:nth-child(3) {
			.number {
				background-color: #003180;
			}
			strong {
				color: #003180;
			}
		}

		.rule-item:nth-child(4) {
			.number {
				background-color: #da006a;
			}
			strong {
				color: #da006a;
			}
		}
	}

	.gallery {
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		grid-auto-rows: 1fr;
		height: 246px;
		overflow: hidden;
		margin-top: 30px;

		img {
			width: 100%;
			height: auto;
		}
	}
}
</style>
